const enum LocalConstants {
  SportsOfferingBase = 'kambi-sports-offering',
}

export const sportsOfferingQueryKeys = {
  SportsOfferingBase: [LocalConstants.SportsOfferingBase],

  get BetOffersBase() {
    return [this.SportsOfferingBase, 'bet-offers']
  },
  BetOffersByIds(betOfferIds: number[]) {
    return [...this.BetOffersBase, 'by-ids', ...betOfferIds]
  },
  BetOffersByEvents(eventIds: number[]) {
    return [...this.BetOffersBase, 'by-events', ...eventIds]
  },
  BetOffersByGroups(groupIds: number[]) {
    return [...this.BetOffersBase, 'by-groups', ...groupIds]
  },

  get EventsBase() {
    return [this.SportsOfferingBase, 'events']
  },
  get UpcomingEventsForAllSports() {
    return [...this.EventsBase, 'upcoming', 'all-sports']
  },
  get LiveEventsForAllSports() {
    return [...this.EventsBase, 'live', 'all-sports']
  },

  EventGroupsFromRoot: [LocalConstants.SportsOfferingBase, 'groups', 'events-groups-from-root'],
  EventGroupHighlights: [LocalConstants.SportsOfferingBase, 'groups', 'highlight'],
  EventsForGroupId: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'events',
  ],
  SgmAvailabilityForGroup: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'sgm-availability',
  ],
  SgmAvailabilityForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'sgm-availability',
  ],
  EventsForSport: (sport: string, categoryId: number | undefined) => [
    LocalConstants.SportsOfferingBase,
    'sport',
    sport,
    'events',
    categoryId,
  ],

  CashOutSpecialEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'cash-out'],
  Group: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
  ],
  EventsForCompetition: (sport: string, region: string, competition: string) => [
    LocalConstants.SportsOfferingBase,
    'sport',
    sport,
    region,
    competition,
  ],
  EventPricingForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'pricing',
  ],
  ParticipantsByLeague: (competitionId: number) => [
    LocalConstants.SportsOfferingBase,
    'league',
    'participants',
    competitionId,
  ],
} as const

// cspell:ignore betoffers
